import {addCategoryApi} from "../../api/entities/categories";
import {createAddSlice} from "../genericCrudSlice";


const createCategorySlice = createAddSlice('category', addCategoryApi);
export const {init: initCreateCategory} = createCategorySlice.actions;
export const {addEntity: createCategory} = createCategorySlice;
export default createCategorySlice.reducer;